import type { PriceRow } from "../data/prices";

// Under every price list on the site (Alan's rule).
export const OrderLine = () => (
  <p className="text-sm text-gray-400">
    Ready to start?{" "}
    <a href="/cart.html" className="text-teal-400 underline underline-offset-2 hover:text-teal-300">
      Order online
    </a>{" "}
    or{" "}
    <a href="/contact.html" className="text-teal-400 underline underline-offset-2 hover:text-teal-300">
      ask us a question
    </a>
    .
  </p>
);

// A plain list of name / what you get / price. Used on every page that shows
// prices so they all read the same way.
const PriceList = ({ rows }: { rows: PriceRow[] }) => (
  <div className="grid gap-3">
    {rows.map((r) => (
      <div key={r.name} className="p-5 rounded-2xl glass sm:flex sm:items-baseline sm:justify-between sm:gap-6">
        <div>
          <h3 className="text-white font-medium">{r.name}</h3>
          {r.desc && <p className="text-gray-400 text-sm leading-relaxed mt-1">{r.desc}</p>}
        </div>
        <p className="text-white font-medium tabular-nums mt-2 sm:mt-0 sm:text-right sm:whitespace-nowrap">{r.price}</p>
      </div>
    ))}
    <OrderLine />
  </div>
);

export default PriceList;
